import { Theme } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React from "react";
import {
  CreateButton,
  Datagrid,
  FunctionField,
  Record,
  sanitizeListRestProps,
  TextField,
  TopToolbar,
  useListContext,
} from "react-admin";
import { RouteComponentProps } from "react-router-dom";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { DvirFormListDto } from "./types";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { DeleteRecordMenuItem } from "../../common/data-grid-fields/DeleteRecordMenuItem";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";

interface Props extends Partial<RouteComponentProps> {}

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const { basePath } = useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      <CreateButton basePath={basePath} />
    </TopToolbar>
  );
};

export const DvirFormsList = (props: Props) => {
  const theme: Theme = useTheme();
  return (
    <div className="content-container">
      <DefaultProLogsList
        title="resources.admin-dvir-forms.name"
        actions={<ListActions />}
        bulkActionButtons={false}
        {...props}>
        <Datagrid>
          <TextField
            source="name"
            label="resources.admin-dvir-forms.labels.name"
          />
          <FunctionField<DvirFormListDto & Record>
            source="isDefault"
            label="resources.admin-dvir-forms.labels.isDefault"
            headerClassName="centered-content"
            render={(record) =>
              record?.isDefault ? (
                <div className="centered-content">
                  <CheckBoxIcon
                    style={{
                      color: theme.palette.success.main,
                    }}
                  />
                </div>
              ) : null
            }
          />
          <ActionsField>
            <DeleteRecordMenuItem hidden={(record) => !!record.isDefault} />
          </ActionsField>
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
